import selectSchedules from './selectSchedules';
import { matchesQuery } from 'services/store/utils-selectors';

const selectSchedulesByQuery = (state, query) => (
  selectSchedules(state).filter(item => matchesQuery(item, query))
);

export default selectSchedulesByQuery;
